import I18n from 'I18n';
export function buildDefaultReminderEmail(includeDescription) {
  const greeting = `<p>${I18n.text('email.reminder.greetingWithName', {
    fullName: '{{ contact.firstname }}'
  })}</p>`;
  const message = `<p>${I18n.text('email.reminder.message')}</p><p><strong>{{ meeting.date }} {{ meeting.time }}</strong></p>`;
  const description = `<p>${I18n.text('email.reminder.descriptionIntro')}</p><p>{{ meeting.description }}</p>`;
  const salutation = `<p>${I18n.text('email.reminder.salutation')}</p><p>{{ host.signature }}</p>`;
  const body = [greeting, message, ...(includeDescription ? [description] : []), salutation].join('<p></p>');
  const subject = I18n.text('email.reminder.subject');
  return {
    body,
    subject
  };
}
export function buildDefaultConfirmationEmail(linkType) {
  const title = `<p>${I18n.text('email.confirmation.header', {
    ownerName: '{{ host.firstname }} {{ host.lastname }}'
  })}</p>`;
  const subject = I18n.text('email.confirmation.subject', {
    ownerName: '{{ host.firstname }} {{ host.lastname }}'
  });
  const emailAddress = `<p>${I18n.text('email.confirmation.emailAddress')}<br />{{ contact.email }}</p>`;
  const dateTime = `<p>${I18n.text('email.confirmation.dateTime')}<br />{{ meeting.date }} {{ meeting.time }}</p>`;
  const location = `<p>${I18n.text('email.confirmation.location')}<br />{{ meeting.location }}</p>`;
  const body = [emailAddress, dateTime, location].join('<p></p>');
  return {
    avatarOption: getDefaultAvatarOption(linkType),
    avatarUrl: '',
    body,
    subject,
    title
  };
}
function getDefaultAvatarOption(linkType) {
  return linkType === 'ROUND_ROBIN_CALENDAR' ? 'COMPANY_LOGO' : 'PROFILE_IMAGE';
}
export function mapImageOptionToAvatarOption(imageOption) {
  switch (imageOption) {
    case 'ORGANIZER_AVATAR':
      return 'PROFILE_IMAGE';
    case 'COMPANY_AVATAR':
      return 'COMPANY_LOGO';
    case 'CUSTOM':
      return 'CUSTOM_AVATAR';
    default:
      return 'PROFILE_IMAGE';
  }
}
export function mapAvatarOptionToImageOption(avatarOption) {
  switch (avatarOption) {
    case 'PROFILE_IMAGE':
      return 'ORGANIZER_AVATAR';
    case 'COMPANY_LOGO':
      return 'COMPANY_AVATAR';
    case 'CUSTOM_AVATAR':
      return 'CUSTOM';
    default:
      return 'ORGANIZER_AVATAR';
  }
}